module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo",
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "normal",
      "margin-top": "20px"
    }
  }, [_vm._v("发票夹做您贴心的发票小助手")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed97b97"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 337
// module chunks = 0